import React, { Component } from "react";
import { ReportGeneratorUtils } from "../../utils/reportGeneratorUtils";
import { switchReportStyle } from "../../Timps/Switch/style/index";
import { themeService } from "../../../../theme/service/activeTheme.service";
import _ from "lodash";
import ReportTitleSection from "../../../../libraries/ReportGenerator/ReportTitleSection";
import ReportInfoSection from "../../../../libraries/ReportGenerator/ReportInfoSection";
import ReportTableSectionRenderer from "../../../../libraries/ReportGenerator";
import { dataFormatters } from "../../../../utils/dataFormatters";

import { WorkGangReportSchema } from "./WorkGangReportSchema";
import { languageService } from "../../../../Language/language.service";

const ReportView = (props) => {
  let reportData = props.reportData ? props.reportData : {};
  let { user, date, formSummary, isMaintenance } = reportData;
  if (!formSummary) formSummary = {};

  let data = {
    user: user ? user.name : "",
    reportDate: dataFormatters.dateFormatter(date),
    ...formSummary,
  };
  let formValue = reportData.isMaintenance
    ? reportData.formSummary && reportData.formSummary.formId
      ? reportData.formSummary.formId
      : null
    : "N/A";
  let reportTitle = reportData.isMaintenance ? "MR Number" : "Title";

  let showTable = data.workerstable && data.workerstable.length > 0 ? true : false;
  return (
    <div className="mainContent table-report last-page-break-print" style={{ ...themeService(switchReportStyle.mainStyle) }}>
      <ReportTitleSection title="Work Gang Report" {...props} centerTitle={true} isMaintenance={isMaintenance} />
      <ReportInfoSection
        fontSizeOverride={"20px"}
        rows={[
          {
            col1: {
              title: reportTitle,
              value: reportData.title,
            },
            col2: {
              title: "Gang Name",
              value: data.gangName,
            },
          },
          {
            col1: {
              title: "Track Inspector",
              value: data.user,
            },

            col2: {
              title: "Form ID",
              value: formValue,
            },
          },

          {
            col1: {
              title: "Date",
              value: data.reportDate,
            },
          },
        ]}
      />

      <span className="spacer"></span>
      <table className="table-bordered" style={{ fontSize: "20px", position: "relative" }}>
        {WorkGangReportSchema.sections.map((section) => {
          return (
            <React.Fragment>
              <ReportTableSectionRenderer section={section} rowsData={data.workerstable} />
            </React.Fragment>
          );
        })}
        {!showTable && (
          <div
            style={{
              position: "absolute",
              top: "48%",
              bottom: "auto",
              left: "50%",
              right: "auto",
              width: "fit-content",
              height: "fit-content",
              padding: "20px",
              fontSize: "50px",
              fontWeight: 600,
              transform: "translate(-50%, -50%)",
              color: "#b3b0b0",
              textTransform: "capitalize",
            }}
          >
            {languageService("No Member Assigned")}
          </div>
        )}
      </table>
    </div>
  );
};

const WorkGangReport = (props) => {
  const { inspec } = props;
  const isMaintenance = props.isMaintenance ? props.isMaintenance : ReportGeneratorUtils.checkIfMaintenance(inspec);
  const title = inspec.title ? inspec.title : null;

  let formSummaries = isMaintenance
    ? ReportGeneratorUtils.getMaintenanceAppForms(inspec, ["workGangAppForm_m"])
    : ReportGeneratorUtils.getInspectionAppForms(inspec, ["workGangAppForm_i"]);

  return formSummaries.map((summary) => {
    return (
      <ReportView
        {...props}
        reportData={{
          formSummary: summary,
          date: ReportGeneratorUtils.getInspectionDate(inspec),
          user: ReportGeneratorUtils.getInspectionUser(inspec),
          isMaintenance: isMaintenance,
          title: title,
        }}
      />
    );
  });
};

export default WorkGangReport;



// WEBPACK FOOTER //
// ./src/components/Reports/PATH/WorkGangReport/index.jsx